import { Grid, LinearProgress, Typography, WithStyles } from '@material-ui/core'
import { withTranslation, WithTranslation } from 'react-i18next'
import { reduxForm } from 'redux-form'
import { ApplicationFormSubmitAction } from '../../../actions/types'
import SubmitFormButton from '../../../components/Buttons/SubmitFormButton'
import ApplicationFormFields from '../Forms/ApplicationFormFields'

interface EditApplicationFormProps extends WithStyles, WithTranslation {
  editApplicationAction: ApplicationFormSubmitAction
  handleSubmit: (arg: any) => any
  error: Error
  submitting: boolean
}

const EditApplicationForm = ({
  t,
  handleSubmit,
  submitting,
  error,
  editApplicationAction
}: EditApplicationFormProps) => (
  <form onSubmit={handleSubmit(editApplicationAction)}>
    <Grid container spacing={1}>
      <ApplicationFormFields t={t} />
      {error && (
        <Typography style={{ color: 'red' }} variant='body1'>
          {error}
        </Typography>
      )}
      <SubmitFormButton submitting={submitting} />
      {submitting && <LinearProgress />}
    </Grid>
  </form>
)

export default reduxForm({
  form: 'EditApplicationForm'
})(withTranslation()(EditApplicationForm as any) as any) as any
